<div class="error-container">
  <h1 class="error-title">Connection Error</h1>
  <p class="error-description">
    We're unable to connect to the service at the moment. This may be due to temporary network issues or scheduled maintenance.
  </p>

  <div class="actions">
    <a routerLink="/" class="btn-dashboard">
      <ng-icon name="lucideInbox"></ng-icon>
      Go to Tenders
    </a>
    <a routerLink="/access/contact-support" class="btn-support">
      <ng-icon name="lucideMail"></ng-icon>
      Contact Support
    </a>
  </div>

  <p class="footer-note">
    If this issue persists, please contact support.
  </p>
</div>
